/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrast ratio helps everyone including many colour-blind users, but it does not replace testing that information is not conveyed by colour alone.`)
};

const es_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ratio de contraste ayuda a todos, incluidos muchos usuarios daltónicos, pero no sustituye a comprobar que la información no se transmite solo mediante el color.`)
};

const de_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Kontrastverhältnis hilft allen, einschließlich vieler farbenblinder Nutzer, ersetzt aber nicht die Prüfung, dass Informationen nicht allein über Farbe vermittelt werden.`)
};

const nl_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrastverhouding helpt iedereen, inclusief veel kleurenblinde gebruikers, maar vervangt niet het testen of informatie niet uitsluitend via kleur wordt overgebracht.`)
};

const fr_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le ratio de contraste aide tout le monde, y compris de nombreux utilisateurs daltoniens, mais il ne remplace pas la vérification que l'information n'est pas transmise par la couleur seule.`)
};

const it_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il rapporto di contrasto aiuta tutti, inclusi molti utenti daltonici, ma non sostituisce il test per verificare che l'informazione non sia trasmessa solo dal colore.`)
};

const pt_br2_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A taxa de contraste ajuda a todos, inclusive muitos usuários daltônicos, mas não substitui testar se a informação não depende só da cor.`)
};

const pt_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O rácio de contraste ajuda todos, incluindo muitos utilizadores daltónicos, mas não substitui testar se a informação não é transmitida apenas pela cor.`)
};

const ja_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コントラスト比は多くの色覚異常の方を含め、誰にとっても役立ちますが、色だけで情報を伝えていないかのテストの代わりにはなりません。`)
};

const zh_cc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比度有助于包括许多色盲用户在内的所有人，但它不能替代“信息不能仅靠颜色传达”这一测试原则。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_a4", locale)
	if (locale === "en") return en_cc_faq_a4(inputs)
	if (locale === "es") return es_cc_faq_a4(inputs)
	if (locale === "de") return de_cc_faq_a4(inputs)
	if (locale === "nl") return nl_cc_faq_a4(inputs)
	if (locale === "fr") return fr_cc_faq_a4(inputs)
	if (locale === "it") return it_cc_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_a4(inputs)
	if (locale === "pt") return pt_cc_faq_a4(inputs)
	if (locale === "ja") return ja_cc_faq_a4(inputs)
	return zh_cc_faq_a4(inputs)
};